import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import { RouterProvider } from "react-router-dom";
import { router as RootRouter } from "./RootRoutes";
import { router as AuthRoutes } from "./AuthRoutes";
import { useAuth } from "../hooks/useAuth";
import Logo from "../components/Logo";

export function Routes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Stack
        width="100vw"
        height="100vh"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        <Logo style={{ width: "35%" }} />
        <LinearProgress sx={{ width: "30%" }} color="primary" />
      </Stack>
    );
  }

  if (user) {
    return <RouterProvider router={RootRouter} />;
  } else {
    return <RouterProvider router={AuthRoutes} />;
  }
}
